<template>
    <el-dialog title="出库" :visible.sync="dialogVisible" width="42%" :close-on-click-modal="false" top="8vh" @close="close">
<!--        <upload-excel-component :on-success="handleSuccess" />-->
        <el-form label-width="100px">
            <el-form-item label="重量kg">
                <el-input size="mini" v-model="formData.channelWeight"></el-input>
            </el-form-item>
            <el-form-item label="长">
              <el-input size="mini" v-model="formData.length"></el-input>
            </el-form-item>
            <el-form-item label="宽">
              <el-input size="mini" v-model="formData.width"></el-input>
            </el-form-item>
            <el-form-item label="高">
              <el-input size="mini" v-model="formData.height"></el-input>
            </el-form-item>
            <el-form-item label="国际运单号">
                <el-input size="mini" v-model="formData.conveyNumber" autofocus></el-input>
            </el-form-item>
            <el-form-item label="最近记录">
                <div style="border: 1px dashed #dcdfe6; border-radius: 4px; padding: 1px; height: 200px; overflow-y: auto;" :class="{ 'flash-animation': areaFlash }">
                    <div v-if="pendingList.length === 0" style="color: #909399; text-align: center;">暂无记录</div>
                    <div v-for="(item, index) in pendingList" :key="item.recordId" :style="getItemStyle(item, index)">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                            <div style="flex: 1; min-width: 0; padding-right: 10px;">
                                <div style="font-weight: bold; font-size: 13px; margin-bottom: 0; line-height: 1.2;">{{ item.conveyNumber }}</div>
                                <div v-if="item.loading" style="color: #909399; font-size: 11px;">查询中...</div>
                                <div v-else-if="item.isOzon === true" style="font-size: 11px; color: #606266; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.2;">
                                    {{ item.channel || '-' }} | {{ item.status || '-' }} | {{ item.shop || '-' }} | {{ item.managers || '-' }} | {{ item.standardRange || '-' }}<span v-if="item.isOverweight" style="color: red; font-weight: bold;"> | 超出{{ item.overweightG }}g</span><span v-if="item.notificationSent" style="color: #67c23a; font-weight: bold; margin-left: 5px;">已发送通知</span>
                                </div>
                                <div v-else-if="item.isOzon === false" style="font-size: 11px; color: #909399;">非ozon订单</div>
                            </div>
                            <div :style="{color: item.isOverweight ? 'red' : 'green', fontWeight: 'bold', fontSize: '14px', whiteSpace: 'nowrap'}">{{ item.channelWeight }}kg</div>
                        </div>
                    </div>
                </div>
            </el-form-item>
        </el-form>
<!--        <el-table :data="tableData" border style="margin-top: 20px;">-->
<!--            <el-table-column label="国际运单号" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <div :style="{color: isRepeat(scope.row) ? 'red' : ''}">{{ scope.row.conveyNumber }}</div>-->
<!--                    &lt;!&ndash; <el-input-->
<!--                        v-model="scope.row.conveyNumber"-->
<!--                        placeholder="请输入内容"-->
<!--                    ></el-input> &ndash;&gt;-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            &lt;!&ndash; @blur="outConveyNumber(scope.row)" &ndash;&gt;-->
<!--            &lt;!&ndash; <el-table-column label="尺寸" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input-->
<!--                        v-model="scope.row.channelSize"-->
<!--                        placeholder="请输入内容"-->
<!--                        :readonly="!scope.row.isEdit"-->
<!--                    ></el-input>-->
<!--                </template>-->
<!--            </el-table-column> &ndash;&gt;-->
<!--            <el-table-column label="长" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.length"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="宽" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.width"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="高" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.height"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="重量" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.channelWeight"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="操作" width="140" align="center">-->
<!--                &lt;!&ndash; <template slot="header">-->
<!--                    <el-button type="primary" size="small" @click="addTable">添加</el-button>-->
<!--                </template> &ndash;&gt;-->
<!--                <template slot-scope="scope">-->
<!--                    &lt;!&ndash; <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        v-if="!scope.row.isEdit"-->
<!--                        @click="scope.row.isEdit = true"-->
<!--                    >编辑</el-button>-->
<!--                    <el-button-->
<!--                        type="success"-->
<!--                        size="small"-->
<!--                        v-else-if="scope.row.isEdit"-->
<!--                        @click="scope.row.isEdit = false"-->
<!--                    >确定</el-button> &ndash;&gt;-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        size="small"-->
<!--                        @click="del(scope)"-->
<!--                    >删除</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--        </el-table>-->
        <span slot="footer" class="dialog-footer">
            <el-row type="flex" justify="space-between" align="middle">
<!--                <div>共 {{ tableData.length }} 条</div>-->
              <div></div>
                <el-button type="primary" @click="OutofstockDetermine" :loading="loadingStatus" :disabled="isDisabled">确 定</el-button>
            </el-row>
            <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        </span>
    </el-dialog>
</template>

<style scoped>
@keyframes flash {
    0%, 100% { background-color: #fff; }
    50% { background-color: #ffe6e6; }
}
.flash-animation {
    animation: flash 0.5s ease-in-out 4;
}
/* 确保所有记录默认有白色背景 */
[v-cloak] .el-dialog .el-dialog__body .el-form-item > div > div {
    background-color: #fff;
}
</style>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
// import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
    name: "Outofstock",
    components: {
        // UploadExcelComponent
    },
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            pendingList: [],
            areaFlash: false, // 控制整个区域闪烁
            formData: {
                conveyNumber: '',
                channelWeight: '',
                length: '1',
                width: '1',
                height: '1',
            },
            loadingStatus: false,
            lastConveyNumber: '', // 记录上次的运单号，用于检测从空变为有值
            lastChannelWeight: '', // 记录上次的重量，用于检测从空变为有值
            recordIdCounter: 0 // 用于生成唯一ID
        };
    },
    watch: {
        // 监听国际运单号变化
        'formData.conveyNumber'(newVal) {
            // 只在运单号变化且与上次不同时才记录
            if (newVal && newVal !== this.lastConveyNumber) {
                this.checkAndRecord()
                this.lastConveyNumber = newVal
            }
        },
        // 监听重量变化（电子秤自动填充重量时需要）
        'formData.channelWeight'(newVal) {
            // 只在重量从空变为有值时才记录（避免电子秤持续变化导致重复记录）
            if (newVal && !this.lastChannelWeight && this.formData.conveyNumber) {
                this.checkAndRecord()
                this.lastChannelWeight = newVal
            }
        }
    },
    computed: {
        isDisabled() {
            const tempConveyNumber = this.tableData.map(item => item.conveyNumber)
            const repeatArr = new Set([...tempConveyNumber])
            if (repeatArr.size === tempConveyNumber.length) return false
            return true
        }
    },
    methods: {
        // 获取列表项样式
        getItemStyle(_, index) {
            return {
                padding: '0 4px',
                borderBottom: index < this.pendingList.length - 1 ? '1px dashed #e4e7ed' : 'none'
            }
        },
        // 检查并记录到待用区域
        checkAndRecord() {
            if (!this.formData.conveyNumber || !this.formData.channelWeight) {
                return
            }
            // 检查是否与第一条记录重复（避免重复添加）
            const firstItem = this.pendingList[0]
            if (firstItem && firstItem.conveyNumber === this.formData.conveyNumber) {
                return
            }

            // 生成唯一ID
            const recordId = ++this.recordIdCounter

            // 添加到最近记录开头（先标记为加载中）
            this.pendingList.unshift({
                recordId: recordId, // 唯一ID
                conveyNumber: this.formData.conveyNumber,
                channelWeight: this.formData.channelWeight,
                loading: true,
                isOzon: null, // null: 未查询, true: ozon订单, false: 非ozon订单
                channel: '',
                status: '',
                shop: '',
                managers: '',
                phone: '',
                standardRange: '',
                overweightG: 0,
                isOverweight: false, // 是否超重
                notificationSent: false // 是否已发送通知
            })

            // 调用API查询运单信息
            this.fetchTrackInfo(this.formData.conveyNumber, recordId)

            // 只保留最近5条记录
            if (this.pendingList.length > 5) {
                this.pendingList.pop()
            }
        },
        // 查询运单信息
        async fetchTrackInfo(trackNumber, recordId) {
            try {
                const response = await fetch('https://ozoncheck.hz.hyxun.top/api/check_track', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ track_number: trackNumber })
                })
                const data = await response.json()

                // 解析标准范围（如 "1 - 2000"）
                const standardRange = data['标准范围_g'] || ''
                let maxWeight = 0
                if (standardRange) {
                    const match = standardRange.match(/[\d.]+/g)
                    if (match && match.length >= 2) {
                        maxWeight = parseFloat(match[1]) // 取上限
                    }
                }

                // 使用实际称重重量判断是否超重（单位转换为克）
                const actualWeightG = parseFloat(this.pendingList.find(item => item.recordId === recordId)?.channelWeight || 0) * 1000
                const overweightG = actualWeightG - maxWeight
                const isOverweight = maxWeight > 0 && overweightG > 0

                // 通过唯一ID找到记录并更新
                const index = this.pendingList.findIndex(item => item.recordId === recordId)
                if (index !== -1) {
                    const updatedRecord = {
                        ...this.pendingList[index],
                        loading: false,
                        isOzon: data.is_ozon,
                        channel: data['配送渠道'] || '',
                        status: data['状态'] || '',
                        orderNumber: data['订单号'] || '',
                        shop: data['所属店铺'] || '',
                        managers: data['所有负责人'] || '',
                        phone: data['联系电话'] || '',
                        currentWeightG: data['当前重量_g'] || 0,
                        standardRange: standardRange,
                        maxWeight: maxWeight,
                        isOverweight: isOverweight,
                        overweightG: isOverweight ? overweightG.toFixed(1) : 0
                    }

                    // 超重时发送通知并触发区域闪烁
                    if (isOverweight && !updatedRecord.notificationSent) {
                        this.sendNotification(updatedRecord)
                        updatedRecord.notificationSent = true
                        // 触发整个区域闪烁
                        this.areaFlash = true
                        // 播放音效
                        this.playOverweightSound()
                    }

                    this.$set(this.pendingList, index, updatedRecord)

                    // 2秒后清除闪烁状态
                    if (isOverweight) {
                        setTimeout(() => {
                            this.areaFlash = false
                        }, 2000)
                    }
                }
            } catch (error) {
                console.error('查询运单信息失败:', error)
                // 通过唯一ID找到记录并更新错误状态
                const index = this.pendingList.findIndex(item => item.recordId === recordId)
                if (index !== -1) {
                    this.$set(this.pendingList, index, {
                        ...this.pendingList[index],
                        loading: false,
                        isOzon: false
                    })
                }
            }
        },
        // 发送超重通知
        async sendNotification(record) {
            try {
                // 解析联系电话（可能是多个，用逗号分隔）
                const phoneStr = record.phone || ''
                const mobiles = phoneStr.split(/[,，]/).map(p => p.trim()).filter(p => p)

                if (mobiles.length === 0) {
                    console.warn('没有联系电话，无法发送通知')
                    return
                }

                // 计算实际重量（克）
                const actualWeightG = parseFloat(record.channelWeight || 0) * 1000

                // 构建消息内容
                const content = `Ozon订单超重通知
订单号：${record.orderNumber || record.conveyNumber}
运单号：${record.conveyNumber}
配送渠道：${record.channel}
所属店铺：${record.shop}
负责人：${record.managers}
实际称重：${actualWeightG.toFixed(0)}g
标准范围：${record.standardRange}
超出：${record.overweightG}g`

                // 调用通知API
                const response = await fetch('https://ozoncheck.hz.hyxun.top/api/notify', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        content: content,
                        mobiles: mobiles
                    })
                })

                const result = await response.json()

                if (result.errcode === 0) {
                    console.log('通知已发送至:', mobiles.join(', '))
                } else {
                    console.error('通知发送失败:', result)
                }
            } catch (error) {
                console.error('通知发送异常:', error)
            }
        },
        // 播放超重音效
        playOverweightSound() {
            try {
                const audio = new Audio('/sounds/overweight.mp3')
                audio.play().catch(error => {
                    console.error('音效播放失败:', error)
                })
            } catch (error) {
                console.error('音效加载异常:', error)
            }
        },
        isRepeat(item) {
          const { conveyNumber } = item
          const resultArr = this.tableData.filter(key => key.conveyNumber === conveyNumber)
          return resultArr.length > 1 ? true : false
        },
        openWebSocket() {
          if (window.WebSocket) {
            this.ws = new WebSocket('ws://localhost:4397/');

            this.ws.onopen = (e) => {
              console.log("连接服务器成功");
              this.ws.send("start");
            }
            this.ws.onclose = (e) => {
              console.log("服务器关闭");
            }
            this.ws.onerror = () => {
              console.log("连接出错");
            }
            this.ws.onmessage = (e) => {
              // console.log(e.data);
              const dataStr = e.data
              this.formData.channelWeight = dataStr
            }
          }
        },
        hanldeKeyup(e) {
            // if (!this.formData.channelWeight || !this.formData.conveyNumber || !this.dialogVisible) return
            if (e.keyCode === 13) {
                // this.addTable()
              this.OutofstockDetermine()
            }
        },
        init() {
            this.dialogVisible = true;
            // this.tableData = [
            //     {
            //         id: 1,
            //         conveyNumber: "",
            //         channelSize: "",
            //         channelWeight: "",
            //         channelName: "",
            //         isEdit: false
            //     }
            // ];
            this.tableData = [];
            this.pendingList = []; // 清空最近记录
            this.areaFlash = false; // 重置区域闪烁状态
            this.lastConveyNumber = ''; // 重置运单号跟踪
            this.lastChannelWeight = ''; // 重置重量跟踪
            this.recordIdCounter = 0; // 重置ID计数器
            this.openWebSocket()
          window.addEventListener('keyup', this.hanldeKeyup)
        },
        close() {
          this.dialogVisible = false;
          this.loadingStatus = false
            // this.$once('hook:beforeDestroy', () => {
          window.removeEventListener('keyup', this.hanldeKeyup)
            // })
        },
        closeLoading() {
          this.loadingStatus = false
          this.formData = {
            conveyNumber: '',
            channelWeight: '',
            length: '1',
            width: '1',
            height: '1',
          }
        },
        addTable() {
            this.tableData.push({
                length: '1',
                width: '1',
                height: '1',

                ...this.formData
            });
            this.formData = {
                conveyNumber: '',
                channelWeight: ''
            }
        },
        del(scope) {
            this.$confirm("您确定要删除此信息吗？", "提示")
                .then(() => {
                    const itemIndex = scope.$index
                    this.tableData.splice(itemIndex, 1)
                })
                .catch(() => {
                    this.$message.info("取消操作");
                });
        },
      OutofstockDetermine() {
          // const data = [];
          // for (const item of this.tableData) {
          //   if (item.conveyNumber && item.length && item.width && item.height && item.channelWeight) {
          //     data.push(item);
          //   } else {
          //     this.$message.warning("请将信息填写完整");
          //     return;
          //   }
          // }
          // if (!data.length) {
          //   this.$message.error("请至少填写一项信息");
          //   return;
          // }
          if (!this.formData.channelWeight) {
            this.$message.warning('请输入重量')
            return
          }
          if (!this.formData.conveyNumber) {
            this.$message.warning('请输入国内运单号')
            return
          }

          this.loadingStatus = true
          this.$emit("confirm", [this.formData]);
        },
        outConveyNumber(row) {
            if (!row.conveyNumber || row.channelName) return;
            const API =
                Baseurl + "logisticsController/getOrderChannelByConveyNumber";
            const paramsData = {
                conveyNumber: row.conveyNumber
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    row.channelName = data.channelName;
                } else {
                    row.conveyNumber = "";
                    this.$message.error(data);
                }
            });
        },
        handleSuccess({ results, header }) {
            this.tableData = results.map((item, index) => {
                return {
                    id: index,
                    conveyNumber: item.运单号,
                    length: item.长,
                    width: item.宽,
                    height: item.高,
                    channelWeight: item.重量
                }
            })
            // this.tableHeader = header
            console.log(results, header)
        }
    }
};
</script>
